import { LegalDocumentPage } from '../components/legal/LegalDocumentPage';
import { accountDeletionSections, accountDeletionTitle } from '../content/legal/accountDeletion';
import { childSafetyStandardsSections, childSafetyStandardsTitle } from '../content/legal/childSafetyStandards';
import { deleteYourDataSections, deleteYourDataTitle } from '../content/legal/deleteYourData';
import { communityGuidelinesSections, communityGuidelinesTitle } from '../content/legal/communityGuidelines';
import { cookiePolicySections, cookiePolicyTitle } from '../content/legal/cookiePolicy';
import { privacyPolicySections, privacyPolicyTitle } from '../content/legal/privacyPolicy';
import { supportPageSections, supportPageTitle } from '../content/legal/supportPage';
import { termsOfServiceSections, termsOfServiceTitle } from '../content/legal/termsOfService';
import { LEGAL_PATHS } from '../content/legal/legalMeta';

const LEGAL_ROUTE_MAP: Record<string, () => JSX.Element> = {
  [LEGAL_PATHS.privacy]: () => (
    <LegalDocumentPage title={privacyPolicyTitle} sections={privacyPolicySections} />
  ),
  [LEGAL_PATHS.terms]: () => (
    <LegalDocumentPage title={termsOfServiceTitle} sections={termsOfServiceSections} />
  ),
  [LEGAL_PATHS.communityGuidelines]: () => (
    <LegalDocumentPage title={communityGuidelinesTitle} sections={communityGuidelinesSections} />
  ),
  [LEGAL_PATHS.childSafetyStandards]: () => (
    <LegalDocumentPage title={childSafetyStandardsTitle} sections={childSafetyStandardsSections} />
  ),
  [LEGAL_PATHS.cookies]: () => (
    <LegalDocumentPage title={cookiePolicyTitle} sections={cookiePolicySections} />
  ),
  [LEGAL_PATHS.support]: () => (
    <LegalDocumentPage title={supportPageTitle} sections={supportPageSections} />
  ),
  [LEGAL_PATHS.accountDeletion]: () => (
    <LegalDocumentPage title={accountDeletionTitle} sections={accountDeletionSections} />
  ),
  [LEGAL_PATHS.deleteData]: () => (
    <LegalDocumentPage title={deleteYourDataTitle} sections={deleteYourDataSections} />
  ),
};

export function resolveLegalPage(pathname: string): (() => JSX.Element) | null {
  const normalized = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  return LEGAL_ROUTE_MAP[normalized] ?? null;
}
